



































import { Component, Vue, Prop } from 'vue-property-decorator';

import { Products } from '@/models/Products';

import DetailsLayout from '@/components/car/DetailsLayout.vue';

@Component({
    name: 'DetailsCar',
    components: {
        DetailsLayout,
    },
})
export default class DetailsCar extends Vue {
    @Prop(Array) private carProducts: Products[];

    private removeProduct(product: Products): void {
        this.$emit('on-remove-product', product);
    }
}
